<template>
  <div>
    <TheHeader />

    <div class="container-fluid">
      <div class="row hero">
        <div
          class="col-12 pt-5 d-flex justify-content-center align-items-center flex-column"
        >
          <h1>Notícias</h1>
          <p class="subtitle pt-2 text-white text-center">
            Noticias exclusivas para associados CDL/BH.
          </p>
        </div>
        <div class="col-12 d-none">
          <div class="form-row form_padrao">
            <div class="form-group flutuante col-md-12 position-relative">
              <input
                type="text"
                name="pesquisar"
                id="pesquisar"
                v-model="pesquisar"
                required
              />
              <i class="material-icons search_icon">search</i>
              <label for="pesquisar" v-if="!pesquisar">Pesquisar...</label>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-5">
        <div class="row" v-if="noticias">
          <div
            class="col-md-4 py-3"
            v-for="noticia in noticias.noticias"
            :key="noticia.id"
          >
            <div class="card shadow-sm border-0 position-relative">
              <a
                :href="urlPortal + '/' + noticia.slug"
                target="_blank"
                class="noticia-link"
              ></a>
              <img
                class="card-img-top"
                :src="noticia.foto"
                :alt="noticia.titulo"
              />
              <div class="card-body">
                <small class="small text-muted mb-2">{{ noticia.data }}</small>
                <h5 class="card-title mt-2">{{ noticia.titulo }}</h5>
                <p class="card-text small">{{ noticia.resumo }}</p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row d-flex align-items-center text-center justify-content-center"
          v-else
        >
          <loading />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";

import { filterByValue } from "../../helpers";
import axios from "axios";

export default {
  name: "Ajuda",
  components: {
    TheHeader,
  },
  data() {
    return {
      pesquisar: "",
      slides: [],
      token: "",
      noticias: null,
      urlPortal: process.env.VUE_APP_URL_PORTAL,
    };
  },
  methods: {
    buscarProdutos(event) {
      this.buscaFiltrada = filterByValue(this.produtos, event.query);
    },
    getNoticias() {
      axios
        .get(process.env.VUE_APP_URL_PORTAL + "/wp-json/editoriais/noticias", {
          headers: {
            Authorization: `Bearer ${process.env.VUE_APP_TOKEN_PORTAL}`,
          },
        })
        .then((response) => {
          this.noticias = response.data;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.msg,
            type: "error",
          });
        });
    },
  },
  created() {
    this.getNoticias();
  },
};
</script>

<style lang="scss" scoped>
.card {
  .noticia-link {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
  min-height: 460px;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: translateY(-10px);
  }
  .card-title {
    font-weight: 600;
    color: #05428e;
    line-height: 1.3rem;
  }
  .card-text {
    color: #888;
    line-height: 1.3rem;
  }
}
.hero {
  min-height: 30vh;
  background: #05428e;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  background-image: url("../../assets/img/bg.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  h1 {
    font-size: 2rem;
    font-weight: 600;
    color: white;
  }
  .subtitle {
    max-width: 600px;
    display: flex;
    margin: 0 auto;
    line-height: 1.3rem;
  }
}

.flutuante {
  background: white;
  max-width: 700px;
  display: flex;
  margin: 0 auto;
}
.search_icon {
  position: absolute;
  top: 30%;
  right: 10px;
}
.form_padrao .form-group.flutuante label {
  left: 0px !important;
}
#pesquisar {
  background: white;
}
</style>
